<div class="page-layout">
  <div class="modal-backdrop">
    <div class="task-modal-card">
      <header class="modal-header ">
        <div class="header-left" *ngIf="totalTasks == 1 || !multiTask">
          <h2 class="modal-title">Task Details</h2>
          <span class="id-badge">#Task Id -{{ taskData?.taskId || '—' }}</span>
        </div>

        <div class="header-left" *ngIf="multiTask && totalTasks > 1">
          <h2 class="modal-title">
            Task Details -
            {{ currentTaskIndex }}
            of {{ totalTasks }}
          </h2>
          <div class="multi-task-nav">
            <button class="nav-btn nav-btn-next" type="button" aria-label="Previous task" (click)="goToPrevTask()"
              [disabled]="!canGoPrev">
              <span class="material-icons">chevron_left</span>
            </button>
            <button class="nav-btn nav-btn-next" type="button" aria-label="Next task" (click)="goToNextTask()"
              [disabled]="!canGoNext">
              <span class="material-icons">chevron_right</span>
            </button>
          </div>
        </div>

        <div class="header-actions">
          <button class="btn-reassign" (click)="openReassignDialog()"
            *ngIf="canCompleteTask && taskData?.taskStatus !== 'Complete'">
            <span class="material-icons">person_add_alt</span> Add New User
          </button>
          <button class="btn-complete" (click)="openCompleteDialog()"
            *ngIf="canCompleteTask && taskData?.taskStatus !== 'Complete'"
            [title]="'You are the ' + (taskData?.createdByName === currentUserName ? 'creator' : 'assignee') + ' of this task'">
            <span class="material-icons">note</span> Complete Task
          </button>
          <span class="material-icons close-icon" (click)="onClose()">close</span>
        </div>
      </header>
      <div *ngIf="!isLoading" class="modal-body-grid">
        <main class="main-content">
          <div class="section-block">
            <label class="section-label">Task Name</label>
            <h3 class="task-headline" title="{{ taskData?.taskName || '—' }}">{{ taskData?.taskName || '—' }}</h3>
          </div>
          <div class="section-block">
            <label class="section-label">Category</label>
            <h3 class="task-headline">{{ taskData?.categoryName || '—' }}</h3>
          </div>
          <div class="section-block">
            <label class="section-label">Goal Name</label>
            <h3 class="task-headline">{{ taskData?.goalName || '—' }}</h3>
          </div>


          <div class="section-block">
            <label class="section-label">Task Description</label>
            <div class="description-text rich-text" *ngIf="descriptionHtml"
                 [innerHTML]="descriptionHtml"></div>
            <div class="description-text rich-text is-empty" *ngIf="!descriptionHtml">
              No description provided.
            </div>
          </div>
          <div class="section-block">
            <label class="section-label">Comments</label>
            <div class="activity-timeline">

              <div class="timeline-item" *ngFor="let comment of taskComments">
                <div class="user-avatar">{{ (comment.createdBy || '?').slice(0,2) }}</div>
                <div class="timeline-content">
                  <div class="timeline-header">
                    <span class="user-name">{{comment.createdBy}}</span>
                    <span class="time">{{formatCommentDate(comment.createdDate)}}</span>
                    <span class="comment-actions" *ngIf="isOwnComment(comment) && taskData?.taskStatus !== 'Complete'">
                      <button class="comment-action-btn" (click)="startEditComment(comment)" title="Edit comment">
                        <span class="material-icons">edit</span>
                      </button>
                      <button class="comment-action-btn delete" (click)="confirmDeleteComment(comment)" title="Delete comment">
                        <span class="material-icons">delete</span>
                      </button>
                    </span>
                  </div>
                  <div class="timeline-detail">
                    <div class="detail-row">
                      <span class="detail-label">Comments:</span>
                      <div *ngIf="editingComment !== comment" class="detail-value" [title]="comment.commentData" [innerHTML]="comment.commentData"></div>
                      <div *ngIf="editingComment === comment" class="edit-comment-box">
                        <ngx-editor-menu [editor]="editEditor" [toolbar]="toolbar"></ngx-editor-menu>
                        <ngx-editor [editor]="editEditor" [(ngModel)]="editText" [disabled]="false" style="height: 150px; border-top: 1px solid #ddd;"></ngx-editor>
                        <div class="edit-actions">
                          <button class="btn-save-edit" (click)="saveEditComment()">Save</button>
                          <button class="btn-cancel-edit" (click)="cancelEditComment()">Cancel</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>



            <div class="add-comment-box" *ngIf="taskData?.taskStatus !== 'Complete'" >
              <div style="border: 1px solid #ddd; border-radius: 4px;">
                <div class="editor">
                  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar">
                  </ngx-editor-menu>
                  <ngx-editor [editor]="editor" [(ngModel)]="newCommentText" [disabled]="false"
                    [placeholder]="'Write a comment...'" style="height: 100px; border-top: 1px solid #ddd;">
                  </ngx-editor>
                </div>
              </div>
              <button class="btn-icon" (click)="postCommentByTaskId()"><span class="material-icons">send</span></button>
            </div>
            <div class="add-comment-box" *ngIf="taskData?.taskStatus === 'Complete'">
              <div style="background: #f5f5f5; padding: 10px; border-radius: 4px; color: #999;">
                Task is complete. Comments are read-only.
              </div>
              <button class="btn-icon" disabled><span class="material-icons">send</span></button>
            </div>
          </div>
        </main>

        <!-- Delete Comment Confirmation Dialog -->
        <div *ngIf="deleteConfirmComment" class="confirmation-backdrop">
          <div class="confirm-dialog">
            <h3>Delete Comment</h3>
            <p>Are you sure you want to delete this comment? This action cannot be undone.</p>
            <div class="dialog-actions">
              <button class="btn-reassign btn-cancel" (click)="cancelDeleteComment()">Cancel</button>
              <button class="btn-reassign btn-confirm" (click)="deleteComment()">Delete</button>
            </div>
          </div>
        </div>

        <aside class="sidebar-meta">

          <div class="meta-card">
            <label>Current Status</label>
            <div class="status-badge" [ngClass]="(taskData?.taskStatus || 'pending').toLowerCase()">
              <span class="material-icons">radio_button_checked</span>
              {{ taskData?.taskStatus || "Pending" }}
            </div>
          </div>

          <div class="meta-group">
            <div class="meta-item">
              <span class="material-icons item-icon">event</span>
              <div class="meta-data">
                <label>Due Date</label>
                <span>{{ taskData?.dueDate | date:'MM/dd/yyyy' }}</span>
              </div>
            </div>
            <div class="meta-item">
              <span class="material-icons item-icon">local_hospital</span>
              <div class="meta-data">
                <label>Hospital</label>
                <span>{{ taskData?.hospitalName || 'none' }}</span>
              </div>
            </div>
            <div class="meta-item">
              <span class="material-icons item-icon">flag</span>
              <div class="meta-data">
                <label>Goal</label>
                <span>{{ taskData?.goalName || 'none' }}</span>
              </div>
            </div>

            <div class="meta-item">
              <span class="material-icons item-icon">account_circle</span>
              <div class="meta-data">
                <label>Assigned To</label>
                <div class="user-chip">
                  <div class="tiny-avatar">{{ (taskData?.assignedTo || '?').slice(0,2) }}</div>
                  <span>{{ taskData?.assignedTo || '—' }}</span>
                </div>
              </div>
            </div>

            <div class="meta-item">
              <span class="material-icons item-icon">person_outline</span>
              <div class="meta-data">
                <label>Created By</label>
                <div class="user-chip">
                  <div class="tiny-avatar">{{ (taskData?.createdByName || '?').slice(0,2) }}</div>
                  <span>{{ taskData?.createdByName || '—' }}</span>
                </div>
              </div>
            </div>

            <div class="meta-item">
              <span class="material-icons item-icon">person_outline</span>
              <div class="meta-data">
                <label>Assignee User List</label>

                <div class="user-chip" *ngFor="let user of taskTagDataUserlist">
                  <div class="tiny-avatar">{{ (user?.displayName || '?').slice(0,2) }}</div>
                  <span>{{ user?.displayName || '—' }}</span>
                </div>

              </div>
            </div>
          </div>
        </aside>
      </div>

      <div *ngIf="isLoading" class="loading-overlay">
        <div style="text-align: center;">
          <img src="/assets/catSpinner.gif" style="width:130px; margin-bottom: 20px;">
          <div style="color:#363636; font-size: 24px;">Please wait...</div>
        </div>
      </div>
    </div>
  </div>
</div>